import styled, { css, keyframes } from 'styled-components';
import { down } from 'styled-breakpoints';

const slideDown = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100%);
  }
  60% {
    opacity: 1;
    transform: translateY(6px);
  }
  80% {
    transform: translateY(-2px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const ring = keyframes`
  0% { transform: rotate(0deg); }
  5% { transform: rotate(14deg); }
  10% { transform: rotate(-12deg); }
  15% { transform: rotate(10deg); }
  20% { transform: rotate(-8deg); }
  25% { transform: rotate(5deg); }
  30% { transform: rotate(-3deg); }
  35% { transform: rotate(0deg); }
  100% { transform: rotate(0deg); }
`;

type CtaBarProps = {
  $color?: string;
};

export const Container = styled.div<CtaBarProps>`
  ${({ theme, $color }) => {
    const color = $color || theme.colors.brand.primary.default;

    return css`
      display: flex;
      align-items: center;
      gap: 0.625rem;
      padding: 0.5625rem 0.75rem 0.5625rem 1rem;
      border-radius: 0.375rem;
      background: color-mix(in srgb, ${color} 6%, transparent);
      border: 1px solid color-mix(in srgb, ${color} 12%, transparent);
      width: fit-content;
      max-width: 100%;
      animation: ${slideDown} 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;

      ${down('md')} {
        padding: 0.5rem 0.625rem 0.5rem 0.75rem;
      }
    `;
  }}
`;

export const IconWrapper = styled.span<CtaBarProps>`
  ${({ theme, $color }) => {
    const color = $color || theme.colors.brand.primary.default;

    return css`
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 1.25rem;
      height: 1.25rem;
      flex-shrink: 0;

      svg {
        width: 0.875rem;
        height: 0.875rem;
        color: ${color};
        transform-origin: 50% 0%;
        animation: ${ring} 3s ease-in-out infinite;
      }
    `;
  }}
`;

export const Text = styled.span`
  font-size: 0.8125rem;
  font-weight: 500;
  color: #3d4f6f;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Button = styled.a<CtaBarProps>`
  ${({ theme, $color }) => {
    const color = $color || theme.colors.brand.primary.default;

    return css`
      padding: 0.3125rem 1rem;
      border-radius: 0.375rem;
      border: none;
      background: ${color};
      color: white;
      font-size: 0.71875rem;
      font-weight: 700;
      font-family: inherit;
      cursor: pointer;
      transition: background 0.15s;
      white-space: nowrap;
      flex-shrink: 0;
      text-decoration: none;

      &:hover {
        filter: brightness(0.9);
      }
    `;
  }}
`;
